import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

// to be use
const headers = {
	Authorization: `Bearer ${token}`,
	"Content-Type": "application/json",
};

export const otherDeductionStagingService = {
	getPayrollOtherAdditions: async (param) => {
		const response = await axios.get(`${domain}/api/OtherAdditionStaging/${param}`, {
			headers: headers,
		});
		return response;
	}
};